import { Assert } from '@team/assert';
import { ImageSources } from '../../types';
import { MIN_PIXEL_RATIO } from '../../const';

export const createImageSet = ({ base, x2, x3, x4 }: ImageSources) => {
  const imageSetPaths = [base, x2, x3, x4]
    .filter(Assert.isString)
    .map((path, offset) => `url('${path}') ${MIN_PIXEL_RATIO + offset + 0.5}x`)
    .join(', ');

  return `image-set(${imageSetPaths})`;
};
